import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface GuideDoc {
  icon: string;
  descriptionKey: string;
}

@Component({
  selector: 'ui-guide-docs',
  templateUrl: './guide-docs.component.html',
  styleUrls: ['./guide-docs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuideDocsComponent {
  @Input() titleKey?: string;
  @Input() subtitleKey?: string;
  @Input() subtitleDescriptionKey?: string;
  @Input() docs!: GuideDoc[];
}
